<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top>
            {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar
        >
        <ClientNav/>
        <v-row dense>
            <v-col cols="12" lg="3" xl="2">
                <ClientSide/>
            </v-col>


            <v-col cols="12" lg="9" xl="10">
                <v-row dense>
                    <v-col cols="12" md="12">
                        <v-card elevation="0" outlined>
                            <v-data-table
                                :headers="headers"
                                :items="investigations"
                                :item-class="rowColor"
                                class=" mt-4"
                                sort-by="OpenDate"
                                sort-desc
                                :loading="isLoading"
                                loading-text="Loading Investigations"
                                :search="search"
                                height="475"
                            >
                                <template v-slot:item.select="{ item }">
                                    <router-link
                                        :to="{
                      name: 'Investigation Logs',
                      params: {clientID: item.ClientID},
                      query: {investigationID: item._id }
                    }"
                                    >
                                        <v-btn
                                            x-small
                                            class="white--text"
                                            color="#2b3990"
                                            @click="setCloseOut(item.CloseOut)"
                                        >
                                            select
                                        </v-btn>
                                    </router-link>
                                </template>

                                <template v-slot:item.CloseOut="{ item }">
                                    <v-chip small :color="item.CloseOut ? 'red' : 'green'" dark>
                                        {{ item.CloseOut ? "Close Out" : "Active" }}
                                    </v-chip>
                                </template>

                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-toolbar-title>Investigations</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                            v-model="search"
                                            clearable
                                            flat
                                            solo-inverted
                                            hide-details
                                            prepend-inner-icon="search"
                                            label="search"
                                            class="desktop"
                                        ></v-text-field>
                                        <v-spacer></v-spacer>

                                        <!-- Investigation Dialog -->
                                      <v-btn color="#2b3990" dark @click="showAdd()">
                                        <v-icon left>add</v-icon>
                                        <span class="hidden-sm-and-down">Add Investigation</span>
                                        <span class="hidden-md-and-up">Add</span>
                                      </v-btn>
                                      <v-btn class="primary ml-3" @click="printTable()">
                                        <v-icon small>print</v-icon>
                                        <span class="hidden-sm-and-down">Print</span>
                                      </v-btn>
                                    </v-toolbar>
                                    <v-text-field
                                        v-model="search"
                                        clearable
                                        flat
                                        solo-inverted
                                        hide-details
                                        prepend-inner-icon="search"
                                        label="search"
                                        class="mobile ml-5 mr-5 mb-3 mt-3"
                                    ></v-text-field>
                                </template>
                                <template v-slot:item.ClientSignature="{ item }">
                                    <v-img
                                        max-height="80"
                                        max-width="150"
                                        :src="item.ClientSignature"
                                    ></v-img>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-icon
                                        small
                                        class="mr-2"
                                        @click="
                      viewInvestigation(item);
                      $event.stopPropagation();
                    "
                                    >
                                        mdi-eye
                                    </v-icon>
                                    <!-- <v-icon small class="mr-2" @click="editInvestigation(item)">
                            mdi-pencil
                          </v-icon> -->
                                    <v-icon
                                        v-if="admin && !isAuditorRole"
                                        small
                                        @click="
                      deleteInvestigation(item);
                      $event.stopPropagation();
                    "
                                    >
                                        mdi-delete
                                    </v-icon>
                                    <!-- <v-icon small @click="addDeal(item)">
                            add
                          </v-icon> -->
                                </template>
                                <template v-slot:no-data>
                                    <v-btn
                                        color="#2b3990"
                                        class="white--text"
                                        @click="getInvestigations()"
                                    >Reset
                                    </v-btn
                                    >
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>
        <report-table
            :reportHeaderText="reportHeaderText"
            :tableHeaders="reportTableHeader"
            :tableData="reportData"
        />

    </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import {mapMutations} from "vuex"
import ReportTable from '@/components/Report/ReportTable.vue';


import moment from "moment";

const url = require("../../client_config/config").url;

export default {
    components: {
        ClientNav,
        ClientSide,
        Foot,
        ReportTable
    },
    data: function () {
        return {
            headers: [
                {
                    text: "Select",
                    align: "start",
                    sortable: false,
                    value: "select",
                },
                {text: "Open Date", value: "OpenDate", width: "10%",},
                {text: "Closed Date", value: "ClosedDate"},
                {text: "Description", value: "Description"},
                {text: "Outcome", value: "Involved"},
                {text: "Status", value: "CloseOut"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            closedDate: '',
            isLoading: false,
            signed: false,
            dialog: false,
            transactionDialog: false,
            editInvestigation: false,
            newInvestigation: false,
            msg: false,
            search: "",
            text: "",
            investigations: [],
            clientID: this.$route.params.clientID,
            userID: "",
            tempData: [],
            titleForm: "New Investigation",
            investigationID: "",
            newOpenDate: "",
            newEntity: "",
            newInvolved: "",
            newClient: "",
            newStaff: "",
            newDescription: "",
            newStaffSignature: "",
            newSignature: "",
            closedBySignature: "",
            uploadImg: "",
            staff: localStorage.getItem("Name"),
            involve: [
                "Staff",
                "Client"
            ],
            employees: [],
            clients: [],
            userState: localStorage.getItem('userState'),
            admin: false,
            menu: false,
            disabled: false,
            CloseOut: false,
            activePicker: null,
            checkedSignature: false,
            checkedClosedBySignature: false,
            category: ["Inconclusive Allegation", "Substantiated Allegation", "Unsubstantiated Allegation",],
            newCategory: "",
        };
    },

    mounted() {
        this.getInvestigations(this.clientID);

    },

    computed: {
        reportHeaderText() {
            return 'Client Investigations';
        },
        reportData() {
            return this.investigations
        },
        reportTableHeader() {
            return this.headers.slice(0, this.headers.length-1);
        },
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
    },

    watch: {},

    created() {
        this.userID = localStorage.getItem("userID");
        if (localStorage.getItem('userRole') === "Administration") {
            this.admin = true;
        }
        this.getEmployees();
        this.getClients()
    },

    methods: {

        ...mapMutations({
            setCloseOut: "investigations/SET_CLOSEOUT",
        }),

        getEmployees() {
            axios.get(`${url}/users/state/${this.userState}`).then(res => {
                this.employees = res.data.users;

            });
        },

        getClients() {
            axios.get(`${url}/clients/state/${this.userState}`).then(async (res) => {
                this.clients = res.data.clients;
            });
        },

        initialize() {
            this.investigations = [];
        },

        viewInvestigation(item) {
            this.$router.push({
                path: `/investigations/${this.clientID}/update/${item._id}`,
                query: {createInvestigation: false}
            })
        },

        showAdd() {
            this.$router.push({
                path: `/investigations/${this.clientID}/new`,
                query: {createInvestigation: true}
            })

        },

        deleteInvestigation(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this investigation?") &&
            this.investigationDelete(id);
        },

        investigationDelete(id) {
            axios.delete(`${url}/investigations/${id}`)
                .then((response) => {
                    this.getInvestigations();
                    if (response.status === 400) {
                        response.json().then(function (data) {
                            return data.msg;
                        });
                    }
                    this.msg = true;
                    this.text = "The investigation has been deleted successfully.";
                });
        },


        rowColor(item) {
            if (item.TransactionMethods === "Cash") {
                return "green lighten-5";
            }

            if (item.TransactionMethods === "Debit Card") {
                return "blue lighten-5";
            }

            if (item.TransactionMethods === "EBT") {
                return "red lighten-5";
            }
        },


        getInvestigations() {
            axios.get(`${url}/investigations/${this.clientID}`).then(res => {
                this.investigations = res.data.investigations.map(item => {
                    return {
                        ...item,
                        OpenDate: moment(item.OpenDate).format('YYYY-MM-DD'),
                        ClosedDate: item?.ClosedDate ? moment(item.ClosedDate).format('YYYY-MM-DD hh:mm A') : '',
                    }
                })

            })
        },

        printTable() {
            document.getElementById('printTable').style.display = "block";
            window.print()
            document.getElementById('printTable').style.display = "none";
        }
    },
};
</script>
<style>
#printTable{
    display: none;
}
.Red {
    background-color: #ffebee;
}

.Green {
    background-color: #e8f5e9;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}

.balance-amount {
    font-size: 40px;
}

.balance-amount--current {
    font-size: 20px;
}

@media print {
    #printTable {
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;
    }

    .hideOnPrint {
      display: none;
      border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none;

    }

    @page { margin: 0; }
    body { margin: 1.6cm; }
  }
</style>
